import { render, staticRenderFns } from "./SwitchView.vue?vue&type=template&id=6ef1a0c5"
import script from "./SwitchView.vue?vue&type=script&lang=js"
export * from "./SwitchView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports